import { call, takeLatest } from "redux-saga/effects";
import * as teamApi from "../apis/teamApi";
import { ADD_TEAM, ADD_TEAM_USER, TEAM_DELETE, TEAM_EDIT, TEAM_LIST, TEAM_USER_DELETE, TEAM_VIEW, TL_DROPDOWN, USERS_DROPDOWN } from "../actions/types";

export function* addTeamWorker(action) {
    try {
        const res = yield call(teamApi.addTeamApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* teamListWorker(action) {
    try {
        const res = yield call(teamApi.teamListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userDropdownWorker(action) {
    try {
        const res = yield call(teamApi.userDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* tlDropDownWorker(action) {
    try {
        const res = yield call(teamApi.teamLeadDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewTeamWorker(action) {
    try {
        const res = yield call(teamApi.viewTeamApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteTeamWorker(action) {
    try {
        const res = yield call(teamApi.deleteTeamApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editTeamWorker(action) {
    try {
        const res = yield call(teamApi.editTeamApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteTeamUserWorker(action) {
    try {
        const res = yield call(teamApi.deleteTeamUserApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* addTeamUserWorker(action) {
    try {
        const res = yield call(teamApi.addTeamUserApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/* Watcher Function*/

export function* addTeamWatcher() {
    yield takeLatest(ADD_TEAM, addTeamWorker);
}

export function* teamListWatcher() {
    yield takeLatest(TEAM_LIST, teamListWorker);
}

export function* userDropdownWatcher() {
    yield takeLatest(USERS_DROPDOWN, userDropdownWorker);
}

export function* tlDropdownWatcher() {
    yield takeLatest(TL_DROPDOWN, tlDropDownWorker);
}

export function* editTeamWatcher() {
    yield takeLatest(TEAM_EDIT, editTeamWorker);
}

export function* deleteTeamWatcher() {
    yield takeLatest(TEAM_DELETE, deleteTeamWorker);
}

export function* viewTeamWatcher() {
    yield takeLatest(TEAM_VIEW, viewTeamWorker);
}

export function* deleteTeamUserWatcher() {
    yield takeLatest(TEAM_USER_DELETE, deleteTeamUserWorker);
}

export function* addTeamUserWatcher() {
    yield takeLatest(ADD_TEAM_USER, addTeamUserWorker);
}